export default "__VITE_ASSET__BIdMBXU$__"